The three-letter ISO 4217 currency code of the product price, in uppercase.

This field is intended for budgeting and not to be directly shown to hirer.

Please contact SEEK before you use this field.
